// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, ".popover-popover-6X8RLloHmwr{display:inline-block}.popover-popover-body-4HTNf3iFmwr{max-height:100vh;overflow:auto}.popover-close-3oKIHJFUmwr{cursor:pointer}.popover-top-container-3cQXO5qKmwr{-webkit-box-align:center;align-items:center;border-bottom:1px solid #DEDEDE;display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;padding:8px}.popover-title-2MahYP4Qmwr{font-size:16px;line-height:20px;margin:0;padding-left:8px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"popover": "popover-popover-6X8RLloHmwr",
	"popover-body": "popover-popover-body-4HTNf3iFmwr",
	"popoverBody": "popover-popover-body-4HTNf3iFmwr",
	"close": "popover-close-3oKIHJFUmwr",
	"top-container": "popover-top-container-3cQXO5qKmwr",
	"topContainer": "popover-top-container-3cQXO5qKmwr",
	"title": "popover-title-2MahYP4Qmwr " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["bold"] + ""
};
module.exports = exports;
